/**
 * Returns formatted phone number (tel:500600600), to support calling from mobile device.
 * Add phone prefix and remove whitespace
 */
export function linkPhoneFormatter(value: string): string {
  return `tel:${value.replace(/\s/g, '')}`;
}
